// extracted by mini-css-extract-plugin
export var content = "GridCard-module--content--17e03";
export var image = "GridCard-module--image--d5f0b";
export var root = "GridCard-module--root--a8cea";